
import React, { Component } from 'react';

import { connect } from 'react-redux';
import axios from '../_services/api/axios';
import withErrorHandler from '../_hoc/withErrorHandler';
import * as actionCreators from '../_store/actions/index';

import ReduxToastr from 'react-redux-toastr'
import { BrowserRouter } from 'react-router-dom'
import { basename } from 'config'

import MainContent from './MainContent'
import Defaults from '../_helpers/Defaults'
import Aux from '../_hoc/_Aux';

import { 
    Loading
  } from 'components'


class App extends Component {
    componentDidMount() {
        this.props.appStartup();
    }

    render() {    
        if(this.props.appStartupState.loading || this.props.translationLoadState.loading) {
            return <Loading />
        }

        if(this.props.appStartupState.successful && this.props.translationLoadState.successful) {
            return (
                <Aux>
                    <div className="wrapper">
                        <ReduxToastr
                        timeOut={4000}
                        newestOnTop={true}
                        preventDuplicates
                        position="top-right"
                        transitionIn="fadeIn"
                        transitionOut="fadeOut"
                        progressBar/>
                        <BrowserRouter basename={basename}>
                            <MainContent/>
                        </BrowserRouter>
                    </div>
                    <Defaults/>
                </Aux>
            );
        }

        return null;
    }
}


const mapStateToProps = state => {
    return {
        appStartupState: state.appStartup,
        translationLoadState: state.translationLoad
    };
};

const mapDispatchToProps = dispatch => {
    return {
        appStartup: () => dispatch(actionCreators.appStartup())
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(App, axios));


// WEBPACK FOOTER //
// ./src/components/App.js